import { orRaw, raw, topLevel } from "../helpers";
import type { ParsedNode, StyleOptions } from "../types";
import { cleanNode } from "../utils/clean";
import { childrenToJson } from "../utils/json";
import { assignLevels } from "../utils/levels";
import { parseList } from "../utils/list";
import { sanitize } from "../utils/sanitize";
import { structureNode } from "../utils/structure";
import { applyStyles } from "../utils/styles";
import { parseTable } from "../utils/table";

const parseNodes = (root: HTMLElement, styles?: StyleOptions): ParsedNode[] => {
  cleanNode(root);
  const parsed = new Map<Element, ParsedNode>();

  topLevel<HTMLTableElement>(root, "table").forEach((table) => parsed.set(table, orRaw(table, parseTable)));
  topLevel<HTMLElement>(root, "ul, ol").forEach((list) => parsed.set(list, orRaw(list, parseList)));

  structureNode(root, (el) => parsed.has(el));
  const nodes = childrenToJson(root, (el) => parsed.get(el));
  assignLevels(nodes, 0);
  return styles ? applyStyles(nodes, styles) : nodes;
};

const parse = (input: string | Element, styles?: StyleOptions): ParsedNode[] | null => {
  let root: HTMLElement;
  try {
    root = sanitize(input);
  } catch {
    return [];
  }
  if (!root.textContent?.trim()) return null;
  const sanitized = root.innerHTML;
  try {
    return parseNodes(root, styles);
  } catch {
    return [raw(sanitized)];
  }
};

export { parse };
